import 'react-multi-carousel/lib/styles.css'
import { useTranslation } from 'react-i18next'

const About = () => {
  const { t } = useTranslation()

  return (
    <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] mt-6 h-full mx-auto">
      {/* <div className="w-full">
        <div className="text-center flex justify-center items-center flex-col text-2xl text-slate-600 font-bold relative pb-[25px]">
          <h2>Top Category</h2>
          <div className="w-[100px] h-[2px] bg-[#059473] mt-4"></div>
        </div>
      </div> */}
      <div className="w-[20%] md:w-[80%] sm:w-[90%] lg:w-[90%]">
        <h2 className="text-md font-bold p-2 rounded-tl-lg rounded-tr-lg bg-slate-200  text-slate-600">
          {t('home.aboutus')}{' '}
        </h2>
      </div>

      <div className="border-t py-4 sm:w-full md:w-full  mx-auto relative  gap-4">
        <p className="text-justify p-6">
          {t('home.about_text')}
        </p>
         
      </div>
    </div>
  )
}

export default About
